import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <span className="footer__logo">ND<span className="footer__logo-accent">TV</span></span>
          <p className="footer__tagline">세계를 스트리밍. 언제 어디서나.</p>
        </div>
        <div className="footer__links">
          <a href="#about">소개</a>
          <a href="#help">도움말</a>
          <a href="#privacy">개인정보</a>
          <a href="#terms">이용약관</a>
          <a href="#contact">문의</a>
        </div>
        <p className="footer__copy">
          &copy; {new Date().getFullYear()} NDTV. 테스트 환경.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
